module.exports = __webpack_public_path__ + "img/audioring2.6b1096a.png";